import { createExcelAndDownload } from '../../../../utils/reportExcelExport';
import dayjs from 'dayjs';

export const filterMembers = (members , filter) => {

    const [[key, value]] = Object.entries(filter);
    let filteredMembers = [];
     switch (key) {
            case "date":
                console.log("Member Filter Successfull!" , value);
                
                //  filteredMembers = members.filter(
                //     member => new Date(member.created_at).toISOString().split('T')[0] >= value.start_date && 
                //               new Date(member.created_at).toISOString().split('T')[0] <= value.end_date
                // );

                // filteredMembers = members.filter(member => {
                //     let formattedDate = new Date(member.created_at).toLocaleDateString('en-GB'); 
                //     let [day, month, year] = formattedDate.split('/'); 
                //     let formattedDateString = `${day}-${month}-${year}`;
                    
                //     return formattedDateString >= value.start_date && formattedDateString <= value.end_date;
                // });  
                filteredMembers = members.filter(member => {
                    let memberDate = dayjs(member.created_at); // Convert member's date to a Date object
                    let fromDate = value.start_date ? dayjs(value.start_date) : null;
                    let toDate = value.end_date ? dayjs(value.end_date) : null;
                
                    return (
                        (!fromDate || memberDate >= fromDate) && // Check if memberDate is after or equal to start_date
                        (!toDate || memberDate <= toDate) // Check if memberDate is before or equal to end_date
                    );
                });          
            
            break;
            case "month":
                filteredMembers = members.filter((member) => {
                    const memberMonth = dayjs(member.created_at).format("MMM");
                    return memberMonth.toLowerCase() === value.toLowerCase();
                  });
                break;
            case "gender":
                filteredMembers = members.filter(
                    (member) => member.gender === value
                  );
                break;
            case "package_id":
                filteredMembers = members.filter(
                    (member) => member?.package_id?._id === value
                  );
                break;
            default:
                 filteredMembers = members
                break;
        }
    return filteredMembers
}


export  function Report(members , filter) {
    const customHeadings = [
        { key: "serial_number", label: "S/R" },
        { key: "member_id", label: "Membership ID" },
        { key: "name", label: "Full Name" },
        { key: "email", label: "Email" , width: 25 },
        { key: "phone", label: "Phone Number" },
        { key: "gender", label: "Gender" },
        { key: "cnic", label: "Cnic" },
        { key: "address", label: "Address" , width: 45 },
        { key: "is_active", label: "Membership Status" },
        { key: "package_id.title", label: "Membership Package" },
        { key: "created_at", label: "Registration Date" , width: 25, isDate: true },
        { key: "subscription_renewed_date", label: "Subscription Start Date" , width: 25, isDate: true },
        { key: "subscription.end_date", label: "Subscription End Date" , width: 25, isDate: true },
        { key: "invoice.registration_fee", label: "Registeration Fee"},
        { key: "invoice.membership_fee", label: "Membership Fee"},
        { key: "invoice.trainer_fee", label: "Trainer Fee"},
        { key: "trainer_id.name", label: "Trainer Name"},
        { key: "invoice.facilities_fee", label: "Facilities Fee"},
        { key: "invoice.other_charges", label: "Other Charges"},
        { key: "transaction.balance_before", label: "Previous Balance"},
        { key: "voucher.paid_amount", label: "Latest Paid Amount"},
        { key: "invoice.payment_date", label: "Paid Date", isDate: true },
        { key: "voucher.invoice_no", label: "Invoice No"},
        { key: "voucher.payment_method", label: "Payment Method", width: 25},
        { key: "voucher.reference_number", label: "Payment Reference", width: 25},
        { key: "voucher.extension date", label: "Voucher Extension Date", width: 25},
        { key: "voucher.extension date", label: "Voucher Updated By", width: 25},
        { key: "restored_at", label: "Re-activation Date" , width: 25, isDate: true},
        { key: "deactivated_at", label: "De-activation Date" , width: 25, isDate: true},
        { key: "balance", label: "Current Balance"},
    ];

    const membersWithSerialNumbers = members.map((member, index) => ({
        ...member,
        subscription_renewed_date: member?.subscription?.renewed_date || member?.subscription?.start_date,
        serial_number: index + 1, // Start from 1
    }));
    createExcelAndDownload("Members_Report", membersWithSerialNumbers, customHeadings, {
        transformCell: (key, value) => {
            if ((key === "deactivated_at" || key === "restored_at") && (value === null || value === "")) {
                return "---";
            }
            if (key === 'is_active') {
                return value ? "Active" : "Expired";
            }
            return value;
        },
    });
}

